/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualitySectionConfig } from '../../models/quality-section-config';

export interface GetQualitySectionConfigs$Params {
  programPeriodConfigId: string;
}

export function getQualitySectionConfigs(
  http: HttpClient,
  rootUrl: string,
  params: GetQualitySectionConfigs$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<QualitySectionConfig>>> {
  const rb = new RequestBuilder(rootUrl, getQualitySectionConfigs.PATH, 'get');
  if (params) {
    rb.path('programPeriodConfigId', params.programPeriodConfigId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<QualitySectionConfig>>;
    })
  );
}

getQualitySectionConfigs.PATH = '/quality-section-configs/{programPeriodConfigId}';
